import React from "react";

function MembershipCategories() {
  return (

    <>

    <div id="inner-hero" className="inner-hero bg-com pt-50 pb-50">
        <div className="container">
            <div className="row">
                <div className="col-lg-12">
                    <div className="inner-text text-center">
                        <div className="inner-title">Membership Categories</div>
                        <ul className="inner-link">
                            <li>Home</li>
                            <li>Membership Categories</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>


    

    <section id="pricing-plan" className="pricing-inner pt-50 pb-50">
        <div className="container">
          
            <div className="row">
                <div className="col-lg-3 col-md-6">
                    <div className="pricing-plan-item">
                        <h2>Turnover From 200 CR. to 1000 CR.</h2>
                   
                        <div className="pricing-plan-price">
                              <br/>
                          <p style={{ padding: "10px" }}>Large organizations seeking market influence, sponsorship opportunities, and strategic positioning within the business community.</p>
                        </div>
                     
                    </div>
                </div>


                <div className="col-lg-3 col-md-6">
                    <div className="pricing-plan-item">
                        <h2>Turnover From 100 CR. to 200 CR.</h2>
                    
                        <div className="pricing-plan-price">
                               <br/>
                           <p style={{ padding: "10px" }}>Medium organizations seeking market influence, sponsorship opportunities, and strategic positioning within the business community.</p>
                        </div>
                      
                      
                    </div>
                </div>


                <div className="col-lg-3 col-md-6">
                    <div className="pricing-plan-item">
                        <h2>Turnover From 50 CR. to 100 CR.</h2>
                        
                         <div className="pricing-plan-price">
                               <br/>
                           <p style={{ padding: "10px" }}>Established firms requiring enhanced visibility, priority lead access, and strategic partnership opportunities for expansion. <br/><br/></p>
                        
                        </div>
                      
                    </div>
                </div>

                 <div className="col-lg-3 col-md-6">
                    <div className="pricing-plan-item">
                          <h2>Turnover From 10 CR. to 50 CR.</h2>
                
                        <div className="pricing-plan-price">
                               <br/>
                           <p style={{ padding: "10px" }}>SMEs and entrepreneurs seeking growth opportunities, networking access, and business development support through chamber resources.</p>
                        </div>
                      
                    </div>
                </div>
            </div>

           <br/>   <br/><br/>
             <div className="row">
               
                <div className="col-lg-12">
                    <div className="about-content">
                        <div className="section-content">
                         
                            <h2 className="section-title">Universal Benefits:</h2>
                            <div className="section-border"><span></span></div>
                        </div>

                       
                        <div className="about-text">
                           <p>All membership levels receive directory listing, networking event access, exclusive discounts, qualified lead sharing, and priority collaboration opportunities that justify investment through measurable business growth.</p>
                        </div>
                           
                        </div>
                    </div>
                </div>
        </div>
    </section>
   




 
    <section id="about-team-information" className="about-team-information-area pt-130 pb-130">
        <div className="container">
            <div className="row">
              
                <div className="col-lg-12">
                    <div className="about-team-information-right row">
                        <div className="col-md-3 col-sm-3">
                            <div className="about-team-information-item">
                                <div className="about-information-icon">
                                    <img src="/assets/img/teams-icon.png"/>
                                </div>
                                <h4>A Great Team</h4>
                               
                            </div>
                        </div>
                          <div className="col-md-3 col-sm-3">
                            <div className="about-team-information-item">
                                <div className="about-information-icon">
                                    <img src="/assets/img/dedicated-icon.png"/>
                                </div>
                                <h4>We Are Dedicated</h4>
                              
                            </div>
                        </div>
                        <div className="col-md-3 col-sm-3">
                            <div className="about-team-information-item">
                                <div className="about-information-icon">
                                    <img src="/assets/img/support-icon.png"/>
                                </div>
                                <h4>Life Time Support</h4>
                              
                            </div>
                        </div>
                       <div className="col-md-3 col-sm-3">
                            <div className="about-team-information-item">
                                <div className="about-information-icon">
                                    <img src="/assets/img/dependable-team-icon.png"/>
                                </div>
                                <h4>Dependable Team</h4>
                              
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
  


 
   


    </>


);
}

export default MembershipCategories;